import React, { SVGProps } from 'react'
const SvgCheckFilled = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect width={14} height={14} fill={props.fill ?? '#23B998'} rx={7} />
    <path
      fill="#FCFCFF"
      d="M9.934 5.332c.157.157.17.403.04.574l-.04.045-3.3 3.3a.438.438 0 0 1-.573.039l-.045-.04-1.65-1.649a.437.437 0 0 1 .574-.658l.045.04 1.34 1.34 2.99-2.99a.438.438 0 0 1 .575-.04l.044.04Z"
    />
  </svg>
)
export default SvgCheckFilled
